// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const GradientEditorContract = contract({
  name: "GradientEditor",
  description: "Edit a multi-stop CSS gradient with token-led stops. A type Select (Linear / Radial / Angular) with reverse + rotate actions, a live full-width preview bar (a Swatch type=\"gradient\"), then a Stops list where each stop is a position %, a colour (ColorPicker token or raw), an opacity %, and a remove button; an add button appends a stop. Token stops resolve to oklch(var(--<token>)) so the preview re-voices with the theme. Emits the structured GradientValue (kept editable + serialisable); the caller turns it into CSS with the exported gradientToCss(value). Use inside a Popover from a FillSection gradient row, or standalone in a theme builder. For a single solid colour use ColorPicker; for a full paint (solid / gradient / image / shader) use FillPicker.",
  import: "@gradeui/ui",
  aliases: ["gradient editor","gradient picker","gradient builder","css gradient editor","stop editor","gradient stops","linear gradient editor","conic gradient editor"],
  composesWith: ["Select","Button","Input","ColorPicker","Swatch","Popover","FillSection"],
  styleDefaults: {"GradientEditor":"flex flex-col gap-3"},
  props: {
  "value": {
      schema: z.unknown(),
      design: "plumbing",
      description: "the structured gradient (type linear/radial/angular, optional angle in deg, ordered stops). NOT a CSS string — render the string via gradientToCss(value).",
  },
  "onChange": {
      schema: z.unknown(),
      design: "event",
      description: "fired with the next structured gradient on any edit",
  },
  },
});
